import React from "react";
import GenericNotificationCard from "components/notifications/NotificationCard";
import { NotificationToastProps } from "types/notification";
import { RaffleWithIdData } from "types/raffles";
import { css } from "styled-components";

const RaffleStartWrapper = ({
  props,
  notificationData,
}: NotificationToastProps<RaffleWithIdData>) => {
  const { id } = props;
  const { description, title, info, type } = notificationData;

  return (
    <GenericNotificationCard
      containerStyles={css`
        max-width: 240px;
      `}
      title={title}
      description={description}
      type={type}
      info={{
        actionButtonText: info.actionButtonText,
        onActionClickLink: `/raffles/${id}`,
      }}
    />
  );
};

export default RaffleStartWrapper;
